import { useCallback, useState } from 'react';

/**
 * Détection « vue partagée » (rôle Plateforme / portefeuille partagé) côté front, par
 * les DONNÉES et non par un flag : le back remplit `brokerName` sur les lignes uniquement
 * dans ce mode. Dès qu'au moins une ligne porte un `brokerName`, on active la colonne
 * « Courtier ». (La facette `courtiers`, elle, s'affiche automatiquement puisqu'elle
 * apparaît dans la réponse /liste/filtres uniquement en vue partagée.)
 *
 * Usage dans une vue liste :
 *   const { isSharedView, detectFromItems } = useSharedViewDetection();
 *   // dans fetchData : detectFromItems(items);
 *   // dans les colonnes : ...(admin || isSharedView ? [colonneCourtier] : [])
 */
export const useSharedViewDetection = () => {
  const [isSharedView, setIsSharedView] = useState(false);

  const detectFromItems = useCallback((items: Array<{ brokerName?: string | null }>) => {
    const shared = items.some((it) => !!it?.brokerName);
    setIsSharedView((prev) => (prev === shared ? prev : shared));
  }, []);

  return { isSharedView, detectFromItems };
};
